import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';
import { IntegrationsService, ConnectionStatus } from './integrations.service';

@Component({
  selector: 'app-integrations-settings',
  standalone: true,
  imports: [CommonModule, MatCardModule, MatButtonModule, MatIconModule, MatChipsModule],
  template: `
    <mat-card class="integration-card" *ngFor="let provider of providers">
      <mat-card-content>
        <div class="provider-row">
          <div class="provider-info">
            <mat-icon>{{ provider.icon }}</mat-icon>
            <span>{{ provider.label }}</span>
          </div>

          <mat-chip *ngIf="status[provider.key]?.connected" class="connected-chip">
            <mat-icon>check_circle</mat-icon> Connected
          </mat-chip>
          <mat-chip *ngIf="!status[provider.key]?.connected" class="disconnected-chip">
            Not connected
          </mat-chip>

          <button mat-raised-button color="primary" (click)="connect(provider.key)">
            {{ status[provider.key]?.connected ? 'Reconnect' : 'Connect' }}
          </button>
        </div>
      </mat-card-content>
    </mat-card>
  `,
  styles: [`
    .integration-card { margin-bottom: 1rem; }
    .provider-row { display: flex; align-items: center; gap: 1rem; }
    .provider-info { display: flex; align-items: center; gap: 0.5rem; flex: 1; }
    .connected-chip { background-color: #dcfce7; color: #166534; }
    .disconnected-chip { background-color: #f3f4f6; color: #6b7280; }
  `]
})
export class IntegrationsSettingsComponent implements OnInit {
  private integrationsService = inject(IntegrationsService);

  providers = [
    { key: 'webex', label: 'Webex', icon: 'videocam' },
    { key: 'google', label: 'Google Meet', icon: 'video_call' },
    { key: 'teams', label: 'Microsoft Teams', icon: 'groups' }
  ];

  status: Record<string, ConnectionStatus | null> = {
    webex: null,
    google: null,
    teams: null
  };

  ngOnInit(): void {
    this.integrationsService.getWebexStatus().subscribe(s => this.status['webex'] = s);
    this.integrationsService.getGoogleStatus().subscribe(s => this.status['google'] = s);
    this.integrationsService.getTeamsStatus().subscribe(s => this.status['teams'] = s);
  }

 connect(providerKey: string): void {
  const authUrl$ = providerKey === 'webex'
    ? this.integrationsService.getWebexAuthUrl()
    : providerKey === 'google'
    ? this.integrationsService.getGoogleAuthUrl()
    : this.integrationsService.getTeamsAuthUrl();

  authUrl$.subscribe({
    next: (res) => {
      window.open(res.authUrl, '_blank', 'noopener,noreferrer');
    },
    error: (err) => {
      console.error(`Failed to start ${providerKey} authorization`, err);
    }
  });
}
}